import { BLOCK_KIND_LABELS } from '../constants';
import * as Models from '../types/models';

export const getBlockLabel = (kind: Models.BlockKind) => BLOCK_KIND_LABELS[kind];
